import type { DomainMapper } from './types';

import local from './local';
import preview from './preview';
import prod from './prod';
import stage from './stage';

const domainMap: DomainMapper[] = [
  ...local,
  ...stage,
  ...preview,
  ...prod,
];

export default domainMap;

export { local, stage, preview, prod };
